import React, {useEffect, useMemo} from 'react';
import PropTypes from 'prop-types';
import {TextField} from '@material-ui/core';
import SelectSbs from 'Sbs/components/SelectSbs';

export default function ProcessOutcomeEditor(props) {
  const {entity, onPropertyChange, onValidityChange} = props;
  const {outcome, outcomeSbs} = entity;
  const handleChangeOutcome = ({target: {value}}) =>
    onPropertyChange({outcome: value});
  const handleChangeOutcomeSbs = (sbs) => onPropertyChange({outcomeSbs: sbs});
  const outcomeErrorText = useMemo(
    () => (!outcome ? 'Outcome cannot be empty' : ''),
    [outcome],
  );

  useEffect(
    () => onValidityChange(!!outcome),
    [onValidityChange, outcome, outcomeSbs],
  );

  return (
    <>
      <TextField
        fullWidth
        label="Outcome"
        type="text"
        value={outcome}
        onChange={handleChangeOutcome}
        error={!outcome}
        helperText={outcomeErrorText}
      />
      <SelectSbs
        label="Outcome SBS"
        value={outcomeSbs}
        onChange={handleChangeOutcomeSbs}
      />
    </>
  );
}

ProcessOutcomeEditor.propTypes = {
  entity: PropTypes.shape({
    outcome: PropTypes.string,
    outcomeSbs: PropTypes.object,
  }),
  onPropertyChange: PropTypes.func.isRequired,
  onValidityChange: PropTypes.func.isRequired,
};
